import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { useUserContext } from '../contexts/UserContext';

const baseUrl = process.env.REACT_APP_API_URL;
const endpointCreateCheckoutCagnotte = `${baseUrl}/checkout-stripe-cagnotte`;

const baseUrlsite = window.location.origin;
const successUrl = `${baseUrlsite}/success-cagnotte`;
const cancelUrl = `${baseUrlsite}/cancel-cagnotte`;

const StripeCagnotteContext = createContext();

export const StripeCagnotteProvider = ({ children }) => {
  const { tokens } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createCagnotteSession = async (priceId, eventId) => {
    setLoading(true);
    setError(null);

    try {
      if (!tokens?.accessToken) throw new Error("Token manquant");

      const payload = {
        priceId,
        quantity: 1,
        mode: "payment",
        eventId,
        successUrl,
        cancelUrl
      };

      const response = await axios.post(endpointCreateCheckoutCagnotte, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokens.accessToken}`,
        },
      });

      const { sessionUrl } = response.data;
      if (!sessionUrl) throw new Error("Aucune URL Stripe retournée");

      return sessionUrl;
    } catch (err) {
      setError(err.message || "Erreur inconnue");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return (
    <StripeCagnotteContext.Provider value={{ createCagnotteSession, loading, error }}>
      {children}
    </StripeCagnotteContext.Provider>
  );
};

export const useStripeCagnotteContext = () => useContext(StripeCagnotteContext);
